import { useEffect, useRef } from "react";
import type { RefObject } from "react";

export const useInfiniteScroll = (
    onLoadMore: () => void,
    hasMore: boolean,
    loading: boolean
): { sentinelRef: RefObject<HTMLDivElement> } => {
    const sentinelRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const currentSentinel = sentinelRef.current;

        if (!currentSentinel) {
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            const firstEntry = entries[0];

            if (firstEntry?.isIntersecting && !loading && hasMore) {
                onLoadMore();
            }
        });

        observer.observe(currentSentinel);

        return () => {
            observer.disconnect();
        };
    }, [hasMore, loading, onLoadMore]);

    return { sentinelRef };
};
